import type { Sale } from "../types";

export type UserRole = "admin" | "manager" | "user";

export const USER_ROLE_CHOICES: { id: UserRole; name: string }[] = [
  { id: "user", name: "resources.sales.roles.user" },
  { id: "manager", name: "resources.sales.roles.manager" },
  { id: "admin", name: "resources.sales.roles.admin" },
];

export const getUserRole = (
  sale: Pick<Sale, "administrator" | "manager">,
): UserRole => {
  if (sale.administrator) return "admin";
  if (sale.manager) return "manager";
  return "user";
};

export const userRoleToFlags = (
  role: UserRole,
): Pick<Sale, "administrator" | "manager"> => ({
  administrator: role === "admin",
  manager: role === "manager",
});
